<ng-container [ngSwitch]="column?.type">
	<ng-container *ngSwitchDefault>
		<div class="f-body-s">
			{{column?.value}}
		</div>
	</ng-container>
</ng-container>

